import { render, staticRenderFns } from "./DevelopAdd.vue?vue&type=template&id=59729374&scoped=true&"
import script from "./DevelopAdd.vue?vue&type=script&lang=js&"
export * from "./DevelopAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59729374",
  null
  
)

export default component.exports